<template>
  <v-card class="elevation-0">
    <v-list two-line>
      <template v-for="(item,index) in items">
        <v-list-tile :key="item.id">
          <v-list-tile-content>
            <v-list-tile-sub-title v-html="item.title"></v-list-tile-sub-title>
            <v-list-tile-title @click="showDetail(item)" v-html="item.content"></v-list-tile-title>
          </v-list-tile-content>
          <v-list-tile-action>
            <v-list-tile-action-text>{{item.createAt}}</v-list-tile-action-text>
          </v-list-tile-action>
        </v-list-tile>
        <v-divider :key="index" v-if="index + 1 < items.length"></v-divider>
      </template>
    </v-list>
    <message-detail ref="message"></message-detail>
  </v-card>
</template>

<script>
import MessageDetail from './MessageDetail'
export default {
  components: { MessageDetail },
  data() {
    return {
      items: []
    }
  },
  mounted() {
    this.load()
  },
  methods: {
    showDetail(item) {
      this.$refs.message.popup(item)
    },
    load() {
      this.$http
        .get('bulletins', {
          params: {
            page: 0,
            size: 3,
            sort: 'meta.updateAt,desc'
          }
        })
        .then(res => {
          this.items = res.data.content
        })
    }
  }
}
</script>

